angular.module('SpidApp')

.factory('StampToPrinter', function () {
    return function (agency, stamp, type) {
        if (!agency || !stamp) {
            throw "StampToPrinter() - Missing parameter"
        }

        var nowDate = new Date()
        var isoNow = nowDate.toISOString()

        switch (type){
            default :
                var defaultOptions = {
                    agencyName : agency.name.toUpperCase(),
                    regate     : agency.code_regate,
                    printDate  : isoNow.substr(0, 10).split('-').reverse().join('/'), // Lazy day
                    printTime  : isoNow.substr(11, 8),
                    price      : (stamp.price).toFixed(2) + ' EUR',
                    stampName  : stamp.label.toUpperCase(),
                    tag        : '',
                    subtag     : ''
                }
            break;
            case 'vignette-sans-date':
                defaultOptions = {
                    agencyName : agency.name.toUpperCase(),
                    regate     : agency.code_regate,
                    price      : (stamp.price).toFixed(2) + ' EUR',
                    stampName  : stamp.label.toUpperCase(),
                    tag        : '',
                    subtag     : ''
                }
            break;
        }
        
        if ('LETTRE RECOMMANDEE R1'.toLowerCase() === stamp.label.toLowerCase()) {
            defaultOptions.tag    = 'R'
            defaultOptions.subtag = 'CR1'
        }

        return defaultOptions
    }
})